import { FormattedMessage } from 'react-intl';
import { Link } from 'react-router';
import { paths } from '@/app/paths';
import { GameCover } from '@/art/GameCover';
import { useLocale } from '@/i18n/useLocale';
import { useSession } from '@/stores/session';
import s from './lobby.module.css';

const DEMOS = ['tile-match', 'color-sort', 'daily-words', 'chess'] as const;

export function GuestDemos() {
  const locale = useLocale();
  const guest = useSession((s) => s.status === 'guest');
  if (!guest) return null;
  return (
    <div className={s.demos} data-testid="guest-demos">
      <h2><FormattedMessage id="lobby.demo.title" /></h2>
      <p><FormattedMessage id="lobby.demo.text" /></p>
      <div className={s.demoGrid}>
        {DEMOS.map((game) => (
          <Link key={game} to={paths.game(locale, game)} className={s.demoLink}>
            <GameCover game={game} width={64} height={64} className={s.demoCover} />
            <span><strong><FormattedMessage id={`common.game.${game}`} /></strong><span><FormattedMessage id={game === 'chess' ? 'lobby.demo.bot' : 'lobby.demo.play'} /></span></span>
          </Link>
        ))}
      </div>
    </div>
  );
}
